import { render, staticRenderFns } from "./OrganismMenuBarEmbedProject.vue?vue&type=template&id=1136a6c5&"
import script from "./OrganismMenuBarEmbedProject.vue?vue&type=script&lang=js&"
export * from "./OrganismMenuBarEmbedProject.vue?vue&type=script&lang=js&"
import style0 from "./OrganismMenuBarEmbedProject.vue?vue&type=style&index=0&id=1136a6c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
